import React from 'react';

import { ServicePageLayoutComponent } from 'design/servicePageLayout';
import { TextComponent } from 'design/text/textComponents';
import { PromocodeRegistrationManagerContent } from './PromocodeRegistrationManagerContent';
import { ContentLayoutComponent } from 'design/contentLayout';
import { useIntlDictionary } from 'hooks/useIntlDictionary';

export const PromocodeRegistrationManager = () => {
  const { promoCodeRegistrationManager: ownDictionary } = useIntlDictionary();

  return (
    <ServicePageLayoutComponent
      size="auto"
      sidebarContent={null}
      bodyContent={
        <ContentLayoutComponent
          title={
            <TextComponent size="l" family="futura">
              {ownDictionary.titleText}
            </TextComponent>
          }
          body={<PromocodeRegistrationManagerContent />}
          backAction={null}
        />
      }
    />
  );
};
